import apiClient from "../core/HttpClient";
import { ServerSetting } from "../models";

export default class ServerSettingService{
    
  url = "/ServerSetting";
  async getServerSettings() {
    return apiClient.get(this.url).then((response) => {
      return response.data;
    });
  }

  async updateServerSetting(data: ServerSetting) {
    return apiClient.put(this.url, data);
  }

}